const prefix = 'scrambl-deleted-account-v1:'
const listeners = new Set<() => void>()
export function isDeletedAccount(userId: string): boolean {
  try {
    return window.localStorage.getItem(prefix + userId) !== null
  } catch {
    return false
  }
}
export function markDeletedAccount(userId: string) {
  // Failure must propagate: the confirmed cleanup receipt remains available.
  window.localStorage.setItem(prefix + userId, 'confirmed')
  for (const listener of listeners) listener()
}
export function subscribeDeletedAccounts(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
if (typeof window !== 'undefined')
  window.addEventListener('storage', event => {
    if (event.key?.startsWith(prefix))
      for (const listener of listeners) listener()
  })
